import { AppProvider, i18Init, namespaces } from "@sundae/gov-toolkit";
import ReactDOM from "react-dom/client";
import { useI18N } from "@sundae/react-hooks";
import resourcesToBackend from "i18next-resources-to-backend";

import "./tailwind.scss";
import { EEX_PATHS } from "./types";
import { Image, Link } from "@sundae/ui-toolkit";

(async () => {
  i18Init(
    (language, namespace, callback) => {
      import(`./translations/${language}/${namespace}.json`).then(({ default: resources }) =>
        callback(null, resources)
      );
    },
    (options) => {
      options.ns = [...options.ns, "butane"];
      options.debug = false;
      return options;
    }
  );
})();

const App = () => {
  const { i18n, t } = useI18N("butane");
  i18n.use(
    resourcesToBackend((language, namespace, callback) => {
      const path = `./translations/${language}/${namespace}.json`;
      import(path).then(({ default: resources }) => callback(null, resources));
    })
  );

  return (
    <AppProvider
      componentProps={{
        header: {
          renderTertiaryNav: undefined,
          showThemeToggle: false,
          renderLogo: () => (
            <Link to="/">
              <Image src="/static/images/logo.svg" className="h-[20px] w-[20px]" />
            </Link>
          ),
          navigationItems: [
            {
              to: "/",
              title: t("navigation.home"),
              getActiveProps() {
                return {
                  className: "active-nav-item",
                };
              },
            },
            {
              to: EEX_PATHS.DOCS,
              title: t("navigation.docs"),
              external: true,
              getActiveProps() {
                return {
                  className: "active-nav-item",
                };
              },
            },
            {
              to: EEX_PATHS.TWITTER,
              title: t("navigation.twitter"),
              external: true,
              getActiveProps() {
                return {
                  className: "active-nav-item",
                };
              },
            },
          ],
        },
      }}
      brand={{
        title: t("title"),
        description: t("description"),
        images: {
          audit_pending: "/static/images/audit_pending.jpg",
          casting_a_vote: "/static/images/casting_a_vote.jpg",
          fatal_error: "/static/images/fatal_error.jpg",
          not_enough_tokens: "/static/images/not_enough_tokens.jpg",
          proposal_created: "/static/images/proposal_created.jpg",
        },
        classes: {
          buttons: {
            // colored: "!bg-none !bg-primary hover:!bg-[#24caffe6]",
            colored:
              "!from-[#24caff] !to-[#ffa564] hover:!from-[#24caff] hover:!to-[#ffa564] !text-black",
          },
        },
      }}
    />
  );
};

const target = document.querySelector("#app");
const root = target && ReactDOM.createRoot(target);
if (root) {
  root.render(<App />);
}
